
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqwWSTYNjIvidOLy4sLgwGTBRE9ycQR4DzfcU22T07FQQMeta } from "/codebuild/output/src1141156140/src/src/pages/faq.vue?macro=true";
import { default as menufliypWzL_EoARIBpYFcxbYfZgvTX3SYrEkuaiVVKOg4Meta } from "/codebuild/output/src1141156140/src/src/pages/menu.vue?macro=true";
import { default as indexMOjUGNXA6nztLGRm_45Oo6_45uxksRX3qIVUbCpeg33pkw0Meta } from "/codebuild/output/src1141156140/src/src/pages/index.vue?macro=true";
import { default as contactYaaqEhNxjSAs86inOERZq3nWYrHGPc8pp_45CK_45V0_M2QMeta } from "/codebuild/output/src1141156140/src/src/pages/contact.vue?macro=true";
import { default as tutorialNywCzV2WuLmNOKNdfLSkG_Yjx2MQZMR7QYNt_8MRSp4Meta } from "/codebuild/output/src1141156140/src/src/pages/tutorial.vue?macro=true";
import { default as agreementLEkmV4NePmBD24VL8IkqpetEbO_hDBn6fRth39dTsk8Meta } from "/codebuild/output/src1141156140/src/src/pages/agreement.vue?macro=true";
import { default as about_45passhwmiEyAgAFXPYkbf36_45jQQ1C_45Si_Wwo64wVYCi9lWisMeta } from "/codebuild/output/src1141156140/src/src/pages/about-pass.vue?macro=true";
import { default as index8SryiGlIMjNS0M1RoaxR_45DLcoHvZeJBblTfc6BKkPvAMeta } from "/codebuild/output/src1141156140/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93kZeZBBhIH81S2Dv6MaFVcGwQWDQF12AK5gfPLCEq6NUMeta } from "/codebuild/output/src1141156140/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancemATS3pgk_D2fh1IYD9FSVwWtV6r545XDU5WRaaVM4G8Meta } from "/codebuild/output/src1141156140/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_LAEpXpjHz9dN7BfxcYh5LgWInau7UCRat6ijlOkk_4Meta } from "/codebuild/output/src1141156140/src/src/pages/notice/[id].vue?macro=true";
import { default as index4lgjz3ta6LUROSliANNvOOTIuXL9RTJZnGXxBnuHYIsMeta } from "/codebuild/output/src1141156140/src/src/pages/coupon/index.vue?macro=true";
import { default as indexqhapBwvUt3bBEjWKfbfX4EMM0O_45rDoDX9weUJfSPGVMMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/index.vue?macro=true";
import { default as indexx022SDWZIKcPe3nn64aeeTvtE6b1eHdDjN7jK0AfkCkMeta } from "/codebuild/output/src1141156140/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93fwkTTuXOzJCFnVCkNqXeGI0_45Vn6qMJ_45WNYvo2drjA7wMeta } from "/codebuild/output/src1141156140/src/src/pages/parking/[id].vue?macro=true";
import { default as indexqcvcHI9Wgu3xfwNNpCL5EvrSzDwK2CwZGt0da11l2u4Meta } from "/codebuild/output/src1141156140/src/src/pages/history/index.vue?macro=true";
import { default as indexSB7m_45ley_b1YOkgOaa7LKGK8ljR2RcvHYUBpCljRW4QMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/index.vue?macro=true";
import { default as indexe3qaay_45EHsZknNF2BRL_7UBn77oRSkRboTsq1FktweAMeta } from "/codebuild/output/src1141156140/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexLjeq69J4fy_G1SewroFY2yG_93lXEfeoK6HIiL8SEQwMeta } from "/codebuild/output/src1141156140/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviQ3d_45bJPF74yIC06iZzA_UAhlD9jwdgryP8zYf4BNvsoMeta } from "/codebuild/output/src1141156140/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editfM_6WQzo3K_qUvtGZfiL_yudM3T9_45vy7I2Zoo1HTcJkMeta } from "/codebuild/output/src1141156140/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementP_guZniXZb_8_45KlytdeCuCle70YWjSY8QDqOqC_45kgooMeta } from "/codebuild/output/src1141156140/src/src/pages/pass-agreement.vue?macro=true";
import { default as index_rfjdtgMXwr38N_5ESsaaiQotF5g59r8Jhy95M5DhG0Meta } from "/codebuild/output/src1141156140/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dCXEd_45JM3op3tWnPCVuOjXQJqb5tytedULi9fNKktN48Meta } from "/codebuild/output/src1141156140/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmcKowFW0POf1Lij3YH68t1lNP7uDqCh0CQQ0G7Aq5mroMeta } from "/codebuild/output/src1141156140/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexH1cKZFd3u45A_UNbed5tlHkfd31qHZPktI_45_45FRzWEN8Meta } from "/codebuild/output/src1141156140/src/src/pages/card/create/index.vue?macro=true";
import { default as indexeJPmZqSR56h_45x2libmfwi7wwKPOixSgLicEh_45dJv_45aMMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmI1tNCIknCxqMLGD59AJ1rJ_45sTplACIiGD8z7P16pph4Meta } from "/codebuild/output/src1141156140/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmotgTl9BcRx68OazjsS2DpL_45SqwqmBbave9kt_rcOKCcMeta } from "/codebuild/output/src1141156140/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeZFoNi24e5vGUpxVX792kqnbG0K9OK_45KZxhgnPqjWilgMeta } from "/codebuild/output/src1141156140/src/src/pages/membership/complete.vue?macro=true";
import { default as registerDuImbtA5buixL_2Q4Q_45F_45UD__458XWDjqvNRI4Uzd70b4Meta } from "/codebuild/output/src1141156140/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93hNTdn3W9GwrTxfuUvFoiuolDBuqdIAQF88I_7OwKSF0Meta } from "/codebuild/output/src1141156140/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmB36EX932lUmOrciQVFrX1FrtdyDGm_45bFhjdgQ9hbFw4Meta } from "/codebuild/output/src1141156140/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93f8uI6IrFbqzdecddlrBS6Irn8Q48Wj_kb_YXRoiMpQEMeta } from "/codebuild/output/src1141156140/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexsXxXBjJUfagN_45z6_4571uVBJJiKq_pkYsk7ZGHUlYlx0UMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codegrsr045VwZMSn_j9Y8PfNk7VeNrQmJ4JgM_l2SoYZgIMeta } from "/codebuild/output/src1141156140/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codef86XFw_45cLxQ5P_45wUSqTg226TmP5bdHWY9kElGu1_45544Meta } from "/codebuild/output/src1141156140/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete2PCtWgk22QR3PYA5ApFesCfYoS88EZTFqbcrtAZdAtYMeta } from "/codebuild/output/src1141156140/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerMHY3ZSKPGoPo2_456uLlH4yM3B8_Br5jkgTgZk0zsXOboMeta } from "/codebuild/output/src1141156140/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeMG7qKJmI3fXTwETVocvIGoSU485vaJlqfiIVgUjzIHsMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexOwhvYAYyTHG0rg2UGi7GBbcNM0_45gdek1OPBwy8Y7DRIMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmLH4FDxcjT_HTlsYGsOrDBtm5bAC8nsb27OrT5PWBi68Meta } from "/codebuild/output/src1141156140/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeTjXDWxpe8tWu1hARE_YOufadigtEzAQYnEwro_gkb9sMeta } from "/codebuild/output/src1141156140/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexad_KfuZafFMjpb7pvV3_0Y2K2IA02V5GoBmIi3_baxQMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93yAh80B6ogrg43MR9mTygBy73QDp3TGEislmvPf9_45n8sMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeVjAUPRxm1oxQYgTeZoWlSztzYbn7n92NDUyrwMNSsF0Meta } from "/codebuild/output/src1141156140/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliashsTyDc_pHg1ykXD1gvmTqsZfOaF21ddqMlVUbV1rOEYMeta } from "/codebuild/output/src1141156140/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleBdmW7qDYppYwPthxhpeMYh_rXS66QkjUv_Zvn7oaYngMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailvP_OokEEpXkFiG3gpNKy6lhvMXwRjSruAnvyoQ6Qh6IMeta } from "/codebuild/output/src1141156140/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmlfJFfY87oFCgaDgG77o_P07Q_45nzJM3ifh0bjmPCYEjoMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentCk9moQTdIJaq1MTemCgdw1U_9_45cjZkfpA7XyEYvnO8wMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmIaahT0r15AUY9BDOQeK84_45qkYN7bz6vu7tWq7dKJNVYMeta } from "/codebuild/output/src1141156140/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateSGJX02Kc_vczBO1q3DI4_450yl2MlHrrhRK7ntP6ode2oMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeZ3VzYvs08AGaCqHnwSGjkTZjQNQFm4JNSxKGuwz1ZYcMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeF_45qpYPat8hQxxSDacw2PVEjCtv7_Ndmw3Q07mOFxhiUMeta } from "/codebuild/output/src1141156140/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password5_Ysi6zeVrU9PucT7f5czENwXzM9nKuoDQhom4a8ZjoMeta } from "/codebuild/output/src1141156140/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasvGuB1La2394n9r_0gmIiXFEr1uLqwUspEGO4yYDfMc0Meta } from "/codebuild/output/src1141156140/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerQL8Ywdlp1Yq7JhF15Dh6TTuDaZgfy7fA5gu0YM1dlj8Meta } from "/codebuild/output/src1141156140/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeMTJdiXsO1MUSyYk_wWRIPzMIaO8dm8oX_h_IleR_45VUsMeta } from "/codebuild/output/src1141156140/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexOVtByxK1717A2wLwg5szYEgSX6fT_E5359vDQ7VwfycMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexAVl_Z16r_45NuObQ9__vgYZfb2FYucKjrhIfmCVwFY_45e4Meta } from "/codebuild/output/src1141156140/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexb2659q53Lj6vn7X8v6Ahfn1i_45E1yAq_b9Rq3rToYbrIMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexvmWRfrr3B539oPJ_Diz_XhTnbNt6yIsexNDJqcr0dnsMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateBmURF13QvgOIhpRYumxVzIjjjgAwajhGASOh7GD4iu4Meta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeGHjOR8ExAOzFudlettnSaLlP7waVu2FyH4CzS4RtVP0Meta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmXaiJfU9VHkQGseNHK_QLPaAyW9AZMoO0doKmRYtAYAoMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexZqHkPpudlUxOWa_iGT3BxqdeQLPaVPkXkRw55GwMPk0Meta } from "/codebuild/output/src1141156140/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeT4PrTIiZjZt0pz06h3_45fXFEx1Mf4rQ1TCg5fS2laM_45wMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatettGFZkvOk3R0158Su3Kb0dvhzKfdeba4_JoqyUIk_JYMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexdcq1KmzswO6ymmw0GdMA1jHT8YkRPkdtYks6kt3xpusMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexkYg2oBZ_45KKbcGbylajl7MdXLCyxo1_45Dtu9jpKBZY1OUMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete9ckak8Ez_13MsSsP1n_wdwbwqSzvydXKNIt_45LBP0tWgMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexrk6Cyu1PPrixCv9_tYbkUByPqHb5ntMfNz0on519dZEMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeF0Qx6IDhP1Z1mLyHUw0zCNZTfYUfhTesu_us0vqBSkwMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexsw_Yn1OvZZ9culCEfBINMaXC6eGvh6DJu_45ae5CDQXDEMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index2ObVofl1jhgLc0_4yt_45p_iz4V7GaWU6saOpbivEO1GcMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexG9LNVLr70URcX1Fj_45XjqDJ_f16vq_45ZYGIVEvA868mJUMeta } from "/codebuild/output/src1141156140/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update9MELMomSvrqaxMLRSSi8g09VFlsaykmGPuQjA9O2lxIMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmswdxKcAfesXQHfStXnE0Fo5e9UFwos07Y3o_cXRYfBYMeta } from "/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menufliypWzL_EoARIBpYFcxbYfZgvTX3SYrEkuaiVVKOg4Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexMOjUGNXA6nztLGRm_45Oo6_45uxksRX3qIVUbCpeg33pkw0Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index4lgjz3ta6LUROSliANNvOOTIuXL9RTJZnGXxBnuHYIsMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexqcvcHI9Wgu3xfwNNpCL5EvrSzDwK2CwZGt0da11l2u4Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexe3qaay_45EHsZknNF2BRL_7UBn77oRSkRboTsq1FktweAMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexLjeq69J4fy_G1SewroFY2yG_93lXEfeoK6HIiL8SEQwMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexH1cKZFd3u45A_UNbed5tlHkfd31qHZPktI_45_45FRzWEN8Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmI1tNCIknCxqMLGD59AJ1rJ_45sTplACIiGD8z7P16pph4Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmotgTl9BcRx68OazjsS2DpL_45SqwqmBbave9kt_rcOKCcMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeZFoNi24e5vGUpxVX792kqnbG0K9OK_45KZxhgnPqjWilgMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerDuImbtA5buixL_2Q4Q_45F_45UD__458XWDjqvNRI4Uzd70b4Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmB36EX932lUmOrciQVFrX1FrtdyDGm_45bFhjdgQ9hbFw4Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codegrsr045VwZMSn_j9Y8PfNk7VeNrQmJ4JgM_l2SoYZgIMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codef86XFw_45cLxQ5P_45wUSqTg226TmP5bdHWY9kElGu1_45544Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete2PCtWgk22QR3PYA5ApFesCfYoS88EZTFqbcrtAZdAtYMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerMHY3ZSKPGoPo2_456uLlH4yM3B8_Br5jkgTgZk0zsXOboMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmLH4FDxcjT_HTlsYGsOrDBtm5bAC8nsb27OrT5PWBi68Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeTjXDWxpe8tWu1hARE_YOufadigtEzAQYnEwro_gkb9sMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexad_KfuZafFMjpb7pvV3_0Y2K2IA02V5GoBmIi3_baxQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeVjAUPRxm1oxQYgTeZoWlSztzYbn7n92NDUyrwMNSsF0Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleBdmW7qDYppYwPthxhpeMYh_rXS66QkjUv_Zvn7oaYngMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailvP_OokEEpXkFiG3gpNKy6lhvMXwRjSruAnvyoQ6Qh6IMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmlfJFfY87oFCgaDgG77o_P07Q_45nzJM3ifh0bjmPCYEjoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentCk9moQTdIJaq1MTemCgdw1U_9_45cjZkfpA7XyEYvnO8wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmIaahT0r15AUY9BDOQeK84_45qkYN7bz6vu7tWq7dKJNVYMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeZ3VzYvs08AGaCqHnwSGjkTZjQNQFm4JNSxKGuwz1ZYcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeF_45qpYPat8hQxxSDacw2PVEjCtv7_Ndmw3Q07mOFxhiUMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password5_Ysi6zeVrU9PucT7f5czENwXzM9nKuoDQhom4a8ZjoMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerQL8Ywdlp1Yq7JhF15Dh6TTuDaZgfy7fA5gu0YM1dlj8Meta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeMTJdiXsO1MUSyYk_wWRIPzMIaO8dm8oX_h_IleR_45VUsMeta || {},
    component: () => import("/codebuild/output/src1141156140/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1141156140/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]